import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.lockScroll()
    this.containerTarget.classList.remove("hidden")

    if (this.data.get("disable-backdrop") !== "true") {
      this.backgroundId = "modal-background"
      document.body.insertAdjacentHTML(
        "beforeend",
        `<div id="${this.backgroundId}" class="fixed inset-0 bg-black/50" style="z-index: 9998;"></div>`,
      )
      this.background = document.querySelector(`#${this.backgroundId}`)
    }
  }

  disconnect() {
    this.unlockScroll()
    this.removeBackground()
  }

  close() {
    this.containerTarget.classList.add("hidden")
    this.unlockScroll()
    this.removeBackground()
    this.element.remove()
  }

  closeBackground(event) {
    if (event.target === this.containerTarget) {
      this.close()
    }
  }

  closeWithKeyboard(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  lockScroll() {
    document.body.style.overflow = "hidden"
  }

  unlockScroll() {
    document.body.style.overflow = ""
  }

  removeBackground() {
    if (this.background) {
      this.background.remove()
      this.background = null
    }
  }
}
